(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["multiple-content-sliders"] && !Shopify.designMode) return;
  try {
    
  class MultipleSliders extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.multipleSlidersTriggers = Array.from(this.querySelectorAll('[data-collection-trigger]'));
      this.multipleSlidersSwipers = Array.from(this.querySelectorAll('[data-collection-swiper]'));

      this.listeners = {
        onClick: this.onClick.bind(this),
        onMouseEnter: this.onClick.bind(this),
        transitionend: this.updateUI.bind(this),
      };

      this.multipleSlidersTriggers.forEach((trigger) => {
        trigger.addEventListener('click', this.listeners.onClick);
        trigger.addEventListener('mouseenter', this.listeners.onMouseEnter);
      });
    }
    disconnectedCallback() {
      this.multipleSlidersTriggers.forEach((trigger) => {
        trigger.removeEventListener('click', this.listeners.onClick);
        trigger.removeEventListener('mouseenter', this.listeners.onMouseEnter);
      });
    }

    onClick(event) {
      event.preventDefault();

      const trigger = event.currentTarget;
      const collectionHandle = trigger.dataset.collectionTrigger;
      this.newCollectionSwiper = this.multipleSlidersSwipers.find((swiper) => swiper.dataset.collectionSwiper === collectionHandle);

      const activeTriggers = this.multipleSlidersTriggers.filter((trigger) => trigger.classList.contains('active'));
      activeTriggers.forEach((trigger) => trigger.classList.remove('active'));
      this.multipleSlidersTriggers.forEach((trigger) => trigger.dataset.collectionTrigger === collectionHandle && trigger.classList.add('active'));

      if (this.newCollectionSwiper) {
        this.activeSwiper = this.multipleSlidersSwipers.find((swiper) => swiper.classList.contains('visible'));
        this.activeSwiper.classList.remove('visible');
        this.activeSwiper.addEventListener('transitionend', this.listeners.transitionend);
      }
    }

    updateUI() {
      this.newCollectionSwiper.classList.add('visible');

      const swiperInstance = this.newCollectionSwiper.querySelector('[data-swiper]').swiper;
      if (swiperInstance) {
        swiperInstance.slideTo(0);
      }

      this.multipleSlidersTriggers = Array.from(this.querySelectorAll('[data-collection-trigger]'));
      this.multipleSlidersSwipers = Array.from(this.querySelectorAll('[data-collection-swiper]'));

      this.activeSwiper?.removeEventListener('transitionend', this.listeners.transitionend);
    }
  }
  customElements.define('multiple-sliders', MultipleSliders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const navigationLinks = document.querySelectorAll('[data-product-info-navigation-link]');
    navigationLinks.forEach((link) => {
      const target = link.href;
      const targetElement = document.getElementById(target.split('#')[1]);

      if (targetElement) {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          window.scrollTo({ top: targetElement.getBoundingClientRect().top + window.pageYOffset - 40 });
        });
      } else {
        link.closest('.swiper-slide').classList.add('hidden');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
